


























































import Vue from "vue";
import { FormEmails } from "@/model/FormEmails";
import { mapGetters } from "vuex";
import { StateSaveFormEmail } from "@/store/formEmail/types_formEmail";
import LoadingDestore from "@/components/LoadingDestore.vue";
import { launchToast } from "@/utils/toast";
import { Messages } from "@/constants/messages";

export default Vue.extend({
  name: "RequestEmailForm",
  components: { LoadingDestore },
  data(): {
    formEmail: FormEmails;
    invalidEmail: boolean;
    invalidName: boolean;
    isLoading: boolean;
    mess: any;
  } {
    return {
      formEmail: {
        name: "",
        email: "",
      },
      invalidEmail: false,
      invalidName: false,
      isLoading: false,
      mess: Messages,
    };
  },
  computed: {
    ...mapGetters(["getFormEmailStatusSave"]),
  },
  methods: {
    submitForm() {
      this.validateEmail();
      this.validateName();
      if (!this.invalidEmail && !this.invalidName) {
        this.$store.dispatch("saveFormEmail", this.formEmail);
      }
    },
    validateName() {
      this.invalidName = this.formEmail.name === "";
    },
    validateEmail() {
      const re = /^[^\s@]+@[^\s@]+$/;
      this.invalidEmail = !re.test(this.formEmail.email);
      console.log("REGX: " + !re.test(this.formEmail.email));
    },
  },
  watch: {
    getFormEmailStatusSave: function () {
      if (this.getFormEmailStatusSave === StateSaveFormEmail.loading) {
        this.isLoading = true;
      } else {
        this.isLoading = false;
        const toastMessage =
          this.getFormEmailStatusSave === StateSaveFormEmail.success
            ? this.mess.email_success
            : this.mess.error_general;
        const toastType =
          this.getFormEmailStatusSave === StateSaveFormEmail.success
            ? "is-success"
            : "is-danger";
        launchToast(toastMessage, toastType);
        if (this.getFormEmailStatusSave === StateSaveFormEmail.success) {
          this.formEmail.name = "";
          this.formEmail.email = "";
        }
      }
    },
  },
});
